<template>
    <div class="roles">
        <div class="form-check-inline">
            <input class="form-check-input" type="checkbox" :id="id" :value="value" v-model="roles" >
            <label class="form-check-label" :for="id">{{title}}</label>
        </div>
    </div>
</template>

<script>
    export default {
        name: "roles",
        props: {
            roles: Array,
            id: String,
            value: String,
            title: String
        }
    }
</script>

<style scoped>

</style>
